import {AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, OnDestroy} from '@angular/core';
import {Chart, ChartOptions, TooltipItem, registerables} from 'chart.js';

Chart.register(...registerables);

@Component({
    selector: 'app-pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.css'],
    standalone: false
})
export class PieChartComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  pieChart: Chart;
  context: CanvasRenderingContext2D;
  @Input() data: any;
  options: ChartOptions<'doughnut'>;
  @ViewChild('pi_chart', { static: true }) myCanvas;

  constructor() {
  }

  ngOnInit() {
    this.options = {
      responsive: true,
      animation: {
        animateScale: true
      },
      plugins: {
        tooltip: {
          enabled: true,
          mode: 'dataset',
          callbacks: {
            // Each dataset carries a custom `tool_type` prefix ('$' for amounts, '#' for counts).
            label: (item: TooltipItem<'doughnut'>) => {
              const prefix = (item.dataset as any).tool_type || '';
              const value = Number(item.parsed);
              return prefix === '$'
                ? prefix + value.toLocaleString('en-us', {minimumFractionDigits: 2})
                : prefix + value;
            }
          }
        },
        legend: {
          position: 'right'
        }
      }
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && !changes.data.firstChange) {
      this.render();
    }
  }

  ngAfterViewInit(): void {
    this.render();
  }

  ngOnDestroy(): void {
    if (this.pieChart) {
      this.pieChart.destroy();
      this.pieChart = null;
    }
  }

  private render(): void {
    if (!this.myCanvas || !this.myCanvas.nativeElement) {
      return;
    }
    this.context = (this.myCanvas.nativeElement as HTMLCanvasElement).getContext('2d');
    if (this.pieChart) {
      this.pieChart.destroy();
    }
    this.pieChart = new Chart(this.context, {
      type: 'doughnut',
      data: this.data || {labels: [], datasets: []},
      options: this.options
    });
  }
}
